import DataModelDesigner from './DataModelDesigner';
import { entities, mockData } from '../../mock/data-model/Company360';

export default function Company360Page() {
  return <DataModelDesigner title="Company 360" entities={entities} mockData={mockData} />;
}
